"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function ws(url) {
  var conn = new WebSocket(url);
  return {
    on: function on(operation, callback) {
      var operationCallback = function operationCallback(event) {
        return callback(event);
      };

      switch (operation) {
        case 'open':
          conn.onopen = operationCallback;
          break;

        case 'close':
          conn.onclose = operationCallback;
          break;

        case 'error':
          conn.onerror = operationCallback;
          break;

        case 'message':
          conn.onmessage = function (event) {
            return callback(event.data);
          };

          break;
      }
    },
    send: function send(msg) {
      conn.send(msg);
    },
    terminate: function terminate(code, reason) {
      conn.close(code, reason);
    },
    getConnection: function getConnection() {
      return conn;
    }
  };
}

exports.ws = ws;